import React from 'react';
import { Link } from 'react-router-dom';
import { useGetQuizzesQuery } from '../../../features/quizzes/quizzesApi';
import AdminQuiz from './AdminQuiz';

const QuizList = () => {
      const { data: quizzes, isError, isLoading } = useGetQuizzesQuery();

      // decide what to show based on the state
      let content = null;
      if (isLoading) {
        content = <div>Loading...</div>;
      }
      if (!isLoading && isError) {
        content = <div>Something went wrong...</div>;
      }
      if (!isLoading && !isError && quizzes.length > 0) {
        content = quizzes.map((quiz) => (
          <AdminQuiz key={quiz.id} quiz={quiz} />
        ));
      }

    return (
      <>
        <div className="w-full flex">
          <Link to="/admin/quizzes/add-quiz" className="btn ml-auto">
            Add Quiz
          </Link>
        </div>
        <div className="overflow-x-auto mt-4">
          <table className="divide-y-1 text-base divide-gray-600 w-full">
            <thead>
              <tr>
                <th className="table-th">Question</th>
                <th className="table-th">Video</th>
                <th className="table-th justify-center">Action</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-600/50">{content}</tbody>
          </table>
        </div>
      </>
    );
};

export default QuizList;